
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, option_type, class_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, ToolId, FormState__startLoading, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../../Shared/Shared.js";
import { HookFlow_hasMandatoryUncompletedHooks, HookFlowProcedureModal, HookFlowSections, HookFlow_update, HookFlow_completedProcedureIds, HookFlow_initStatusChange, HookFlowState_$reflection, HookFlowMsg_$reflection } from "../../../Widgets/Procedure/Hooks.js";
import { ToolWithQuantityStateChangedDto, ToolWithQuantityDetailDto_$reflection } from "../../../Shared/Tool.js";
import { InventoryStateDefinition_$reflection } from "../../../Shared/InventoryStates.js";
import { ProcedureEntityReferenceDto } from "../../../Shared/Procedure.js";
import { singleton as singleton_1, ofArray, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none, Cmd_map } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { unwrap, map as map_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../../Common.js";
import { putStateChanged } from "../../../Requests/ToolWithQuantity.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { dialogTitle, dateLabel, DescriptionHint } from "../../../InventoryStates/Display.js";
import { DatePicker } from "../../../Components/DatePicker.js";
import { TextArea } from "../../../Components/TextArea.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../../Components/Dialog.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateState", "SetComment", "SetDate", "StateUpdated", "HookMsg", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.ToolWithQuantity.Dialogs.StateChangeDialog.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", HookFlowMsg_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(Tool, Target, Comment$, Date$, Hooks, OnClose, SuccessCallback, FormState) {
        super();
        this.Tool = Tool;
        this.Target = Target;
        this.Comment = Comment$;
        this.Date = Date$;
        this.Hooks = Hooks;
        this.OnClose = OnClose;
        this.SuccessCallback = SuccessCallback;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Tools.ToolWithQuantity.Dialogs.StateChangeDialog.State", [], State, () => [["Tool", ToolWithQuantityDetailDto_$reflection()], ["Target", InventoryStateDefinition_$reflection()], ["Comment", string_type], ["Date", option_type(class_type("System.DateTime"))], ["Hooks", HookFlowState_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()]]);
}

function init(tool, target, successCallback, onClose) {
    const patternInput = HookFlow_initStatusChange(new ProcedureEntityReferenceDto(1, [tool.Id]), map((category) => parse(category.CategoryId), tool.Categories), target.Key);
    return [new State(tool, target, "", undefined, patternInput[0], onClose, successCallback, FormState_get_empty()), Cmd_map((Item) => (new Msg(4, [Item])), patternInput[1])];
}

function update(msg, state) {
    switch (msg.tag) {
        case 2:
            return [new State(state.Tool, state.Target, state.Comment, msg.fields[0], state.Hooks, state.OnClose, state.SuccessCallback, state.FormState), Cmd_none()];
        case 1:
            return [new State(state.Tool, state.Target, msg.fields[0], state.Date, state.Hooks, state.OnClose, state.SuccessCallback, state.FormState), Cmd_none()];
        case 0: {
            const dto = new ToolWithQuantityStateChangedDto(undefined, state.Target.Key, state.Comment, map_1(toISOString, state.Date), HookFlow_completedProcedureIds(state.Hooks));
            return [new State(state.Tool, state.Target, state.Comment, state.Date, state.Hooks, state.OnClose, state.SuccessCallback, FormState__startLoading(state.FormState)), putStateChanged(new ToolId(parse(state.Tool.Id)), dto, (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(5, [Item_3])))];
        }
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Tool, state.Target, state.Comment, state.Date, state.Hooks, state.OnClose, state.SuccessCallback, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Target, state.Comment, state.Date, state.Hooks, state.OnClose, state.SuccessCallback, FormState_get_empty()), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 5:
            return [new State(state.Tool, state.Target, state.Comment, state.Date, state.Hooks, state.OnClose, state.SuccessCallback, FormState_get_empty()), Cmd_none()];
        default: {
            const patternInput = HookFlow_update(msg.fields[0], state.Hooks);
            return [new State(state.Tool, state.Target, state.Comment, state.Date, patternInput[0], state.OnClose, state.SuccessCallback, state.FormState), Cmd_map((Item) => (new Msg(4, [Item])), patternInput[1])];
        }
    }
}

function DialogBody(props) {
    let elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems = toList(delay(() => append(singleton(createElement(DescriptionHint, {
        Definition: props.Target,
    })), delay(() => append(singleton(createElement(HookFlowSections, {
        Dispatch: (arg) => {
            props.Dispatch(new Msg(4, [arg]));
        },
        FormState: props.FormState,
        ReceiverTitleKey: "",
        SenderTitleKey: "procedure.hooks.status_change_procedures",
        State: props.Hooks,
        TestIdPrefix: "state-change",
    })), delay(() => append(singleton(createElement(HookFlowProcedureModal, {
        Dispatch: (arg_1) => {
            props.Dispatch(new Msg(4, [arg_1]));
        },
        State: props.Hooks,
    })), delay(() => {
        let matchValue;
        return append((matchValue = dateLabel(t, false, props.Target), (matchValue == null) ? (empty()) : singleton(createElement(DatePicker, {
            ComponentState: componentState,
            IsClearable: true,
            Label: matchValue,
            OnChange: (arg_2) => {
                props.Dispatch(new Msg(2, [arg_2]));
            },
            TestId: "state-change-dialog-date-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
            Value: unwrap(props.Date),
        }))), delay(() => append(singleton(createElement(TextArea, {
            ComponentState: componentState,
            Label: t("general.comment"),
            OnChange: (arg_3) => {
                props.Dispatch(new Msg(1, [arg_3]));
            },
            TestId: "tool-state-change-dialog-comment-test-id",
            Value: props.Comment,
        })), delay(() => {
            const matchValue_1 = FormState__getValidation(props.FormState, t, "global");
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                return singleton(createElement(ErrorAlert, {
                    Label: matchValue_1,
                }));
            }
        }))));
    })))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function StateChangeDialog(props) {
    let Title, Label_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.ToolWithQuantity, props.Target, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen, props.Target.Key]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = dialogTitle(t, patternInput[1], props.Target), {
        Body: singleton_1(createElement(DialogBody, {
            Comment: state_1.Comment,
            Date: unwrap(state_1.Date),
            Dispatch: dispatch,
            FormState: state_1.FormState,
            Hooks: state_1.Hooks,
            Target: props.Target,
            ToolWithQuantity: props.ToolWithQuantity,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-state-change-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_1 = t("general.save"), {
            ComponentState: (state_1.FormState.IsLoading ? true : HookFlow_hasMandatoryUncompletedHooks(state_1.Hooks)) ? "disabled" : "enabled",
            Label: Label_1,
            OnClick: () => {
                dispatch(new Msg(0, []));
            },
            TestId: "save-state-change-dialog-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

